import React from 'react';
import { Switch, Route } from 'react-router';

// Utils
import { lazyWithRetry } from 'Shared/utils/retry';

// Types
import { Feature } from 'Shared/types/Organization.type';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useFeature } from 'Shared/utils/hooks';

// Components
import PerformanceReviewFreePlanContent from '../PerformanceReviewFreePlanContent/PerformanceReviewFreePlanContent';
const PerformanceReviews = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../PerformanceReviews/PerformanceReviews')
);

const PerformanceReviewsAdministration = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../PerformanceReviewsAdministration/PerformanceReviewsAdministration')
);

const PerformanceReviewCompilationPage = lazyWithRetry(() =>
  import(/* webpackPrefetch: true */ '../PerformanceReviewCompilationPage/PerformanceReviewCompilationPage')
);

const PerformanceReviewsRouteWrapper = () => {
  const { isFreePlan } = useFeature(Feature.performanceReviews);

  if (isFreePlan) return <PerformanceReviewFreePlanContent />;

  return (
    <Switch>
      <Route path={PageUrls.PERFORMANCE_REVIEWS_ADMIN} component={PerformanceReviewsAdministration} />
      <Route
        path={[PageUrls.PERFORMANCE_REVIEWS, PageUrls.PERFORMANCE_REVIEWS_PAST]}
        component={PerformanceReviews}
        exact
      />
      <Route path={PageUrls.PERFORMANCE_REVIEWS_REVIEW} component={PerformanceReviewCompilationPage} exact />
    </Switch>
  );
};

export default PerformanceReviewsRouteWrapper;
